import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Arrow Right Icon from Figma
 * @link [Figma](https://www.figma.com/design/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=279-23337&t=CM4uXZJ1f4wRoSoe-4)
 * */

const ArrowRightIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path className="stroke-current" strokeLinecap="round" d="m4 2 4 4.002L4 10" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowRightIcon;